// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".em-divider{height:1px;width:100%;background-color:#f0f0f0}", ""]);
// Exports
module.exports = exports;
